import {
  deleteAdminReview,
  getReportedReviewsBundle,
  listAdminReviews,
  purgeOrphanedReviewReports,
  resolveReviewReport,
  setAdminReviewVisibility,
} from '@/services/api/adminReviewsApi';
import { invalidateReviewCaches } from '@/utils/cacheUtils';
import { QueryClient } from '@tanstack/react-query';

export interface AdminActionResult {
  success: boolean;
  error?: string;
}

export const adminService = {
  async listReviewsForModeration(filterReported: boolean) {
    return listAdminReviews(filterReported);
  },
  async getReportedReviewsBundle() {
    return getReportedReviewsBundle();
  },
  async resolveReviewReport(reportId: string, resolutionNotes?: string | null) {
    try {
      await resolveReviewReport({ reportId, resolutionNotes: resolutionNotes ?? null });
      return { success: true };
    } catch (e: unknown) {
      return { success: false, error: e instanceof Error ? e.message : 'Unknown error' };
    }
  },
  async purgeOrphanedReviewReports() {
    try {
      const result = await purgeOrphanedReviewReports();
      return { success: true, data: result };
    } catch (e: unknown) {
      return { success: false, error: e instanceof Error ? e.message : 'Unknown error' };
    }
  },
  async updateReviewVisibility(reviewId: string, isPublic: boolean, queryClient?: QueryClient, providerId?: string) {
    try {
      await setAdminReviewVisibility({ reviewId, isPublic });
      if (queryClient && providerId) {
        await invalidateReviewCaches(queryClient, providerId, { clearLocalStorage: true, forceRefetch: true });
      }
      return { success: true };
    } catch (e: unknown) {
      return { success: false, error: e instanceof Error ? e.message : 'Unknown error' };
    }
  },
  async deleteReview(reviewId: string, queryClient?: QueryClient, providerId?: string) {
    try {
      await deleteAdminReview({ reviewId });
      if (queryClient && providerId) {
        await invalidateReviewCaches(queryClient, providerId, { clearLocalStorage: true, forceRefetch: true });
      }
      return { success: true };
    } catch (e: unknown) {
      return { success: false, error: e instanceof Error ? e.message : 'Unknown error' };
    }
  }
};

export type AdminService = typeof adminService;
